import { getUrlFromStoryblokLink } from "@utils/storyblok"
import type { ContentHighlight } from "experiments/SaveAStep/NavHeading"

/**
 * Maps Storyblok ContentHighlight array to processed format.
 * Extracts first item and converts Asset to filename string.
 *
 * @param storyblokData - Array of ContentHighlight from Storyblok CMS
 * @returns Processed ContentHighlight ready for navigation components, or undefined if no data
 */
export function mapContentHighlight(
  storyblokData?: Storyblok.ContentHighlight[]
): ContentHighlight | undefined {
  const item = storyblokData?.[0]
  if (!item) return undefined

  return {
    title: item.title,
    description: item.description,
    ctaTitle: item.ctaTitle,
    ctaDescription: item.ctaDescription,
    ctaLink: getUrlFromStoryblokLink(item.ctaLink),
    ctaImage: item.ctaImage?.filename || "",
    ctaColor: item.ctaColor,
  }
}
